import { render } from "./FormCategoryComponent.vue?vue&type=template&id=0190557b&scoped=true"
import script from "./FormCategoryComponent.vue?vue&type=script&lang=js"
export * from "./FormCategoryComponent.vue?vue&type=script&lang=js"

import "./FormCategoryComponent.vue?vue&type=style&index=0&id=0190557b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0190557b"]])

export default __exports__